/**
 * Generated from PostcardNairobi2Layout.fla
 */
export function PostcardNairobi2Layout(this: IPostcardNairobi2Layout) {
	const main = this.main;
	PostcardNairobi2Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardNairobi2Layout_main(this: IPostcardNairobi2Layout_main) {
	const postcard = this.postcard;
	PostcardNairobi2Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardNairobi2Layout_postcard(this: IPostcardNairobi2Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardNairobi2Layout_cardTransform1.call(cardTransform[0] as IPostcardNairobi2Layout_cardTransform1);
		cardTransform[0].x = 556.6;
		cardTransform[0].y = 262.45;
		cardTransform[0].width = 477.40;
		cardTransform[0].height = 598.41;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardNairobi2Layout_cardTransform2.call(cardTransform[1] as IPostcardNairobi2Layout_cardTransform2);
		cardTransform[1].x = -571.5;
		cardTransform[1].y = -181.05;
		cardTransform[1].width = 482.12;
		cardTransform[1].height = 604.32;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardNairobi2Layout_cardTransform3.call(cardTransform[2] as IPostcardNairobi2Layout_cardTransform3);
		cardTransform[2].x = -643.45;
		cardTransform[2].y = -172.3;
		cardTransform[2].width = 462.95;
		cardTransform[2].height = 580.30;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardNairobi2Layout_cardTransform4.call(cardTransform[3] as IPostcardNairobi2Layout_cardTransform4);
		cardTransform[3].x = -129.3;
		cardTransform[3].y = 388.6;
		cardTransform[3].width = 75.66;
		cardTransform[3].height = 94.83;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardNairobi2Layout_cardTransform5.call(cardTransform[4] as IPostcardNairobi2Layout_cardTransform5);
		cardTransform[4].x = -603.25;
		cardTransform[4].y = 329.3;
		cardTransform[4].width = 535.93;
		cardTransform[4].height = 671.77;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardNairobi2Layout_cardTransform6.call(cardTransform[5] as IPostcardNairobi2Layout_cardTransform6);
		cardTransform[5].x = 296.85;
		cardTransform[5].y = -62;
		cardTransform[5].width = 589.32;
		cardTransform[5].height = 738.70;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardNairobi2Layout_cardTransform7.call(cardTransform[6] as IPostcardNairobi2Layout_cardTransform7);
		cardTransform[6].x = 573.6;
		cardTransform[6].y = -310.25;
		cardTransform[6].width = 586.02;
		cardTransform[6].height = 734.56;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardNairobi2Layout_cardTransform8.call(cardTransform[7] as IPostcardNairobi2Layout_cardTransform8);
		cardTransform[7].x = -47.65;
		cardTransform[7].y = -277.3;
		cardTransform[7].width = 734.55;
		cardTransform[7].height = 920.74;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		PostcardNairobi2Layout_pieces8.call(items[0] as IPostcardNairobi2Layout_pieces8);
		items[0].x = -50.55;
		items[0].y = -286.25;
		items[0].width = 578.00;
		items[0].height = 548.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardNairobi2Layout_outlines8.call(items[1] as IPostcardNairobi2Layout_outlines8);
		items[1].x = -50.95;
		items[1].y = -288.95;
		items[1].width = 578.00;
		items[1].height = 543.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		PostcardNairobi2Layout_pieces7.call(items[2] as IPostcardNairobi2Layout_pieces7);
		items[2].x = 580.8;
		items[2].y = -306.85;
		items[2].width = 425.00;
		items[2].height = 456.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardNairobi2Layout_outlines7.call(items[3] as IPostcardNairobi2Layout_outlines7);
		items[3].x = 565.7;
		items[3].y = -309.5;
		items[3].width = 395.00;
		items[3].height = 450.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		PostcardNairobi2Layout_pieces6.call(items[4] as IPostcardNairobi2Layout_pieces6);
		items[4].x = 276.8;
		items[4].y = -58.35;
		items[4].width = 327.00;
		items[4].height = 512.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardNairobi2Layout_outlines6.call(items[5] as IPostcardNairobi2Layout_outlines6);
		items[5].x = 276.8;
		items[5].y = -61.4;
		items[5].width = 327.00;
		items[5].height = 508.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		PostcardNairobi2Layout_pieces2.call(items[6] as IPostcardNairobi2Layout_pieces2);
		items[6].x = -551.3;
		items[6].y = -189.7;
		items[6].width = 387.99;
		items[6].height = 418.99;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardNairobi2Layout_outlines2.call(items[7] as IPostcardNairobi2Layout_outlines2);
		items[7].x = -546;
		items[7].y = -190.15;
		items[7].width = 379.00;
		items[7].height = 420.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,undefined);
	}
	if (items[8]) {
		PostcardNairobi2Layout_pieces5.call(items[8] as IPostcardNairobi2Layout_pieces5);
		items[8].x = -625.45;
		items[8].y = 297.5;
		items[8].width = 438.00;
		items[8].height = 487.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardNairobi2Layout_outlines5.call(items[9] as IPostcardNairobi2Layout_outlines5);
		items[9].x = -625.85;
		items[9].y = 291.6;
		items[9].width = 438.00;
		items[9].height = 473.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,undefined);
	}
	if (items[10]) {
		PostcardNairobi2Layout_pieces4.call(items[10] as IPostcardNairobi2Layout_pieces4);
		items[10].x = 99.4;
		items[10].y = 271.3;
		items[10].width = 535.00;
		items[10].height = 508.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,undefined);
	}
	if (items[11]) {
		PostcardNairobi2Layout_outlines4.call(items[11] as IPostcardNairobi2Layout_outlines4);
		items[11].x = 98.7;
		items[11].y = 271.2;
		items[11].width = 536.00;
		items[11].height = 508.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardNairobi2Layout_pieces1.call(items[12] as IPostcardNairobi2Layout_pieces1);
		items[12].x = 621.8;
		items[12].y = 195.95;
		items[12].width = 505.00;
		items[12].height = 692.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardNairobi2Layout_outlines1.call(items[13] as IPostcardNairobi2Layout_outlines1);
		items[13].x = 555.4;
		items[13].y = 261.85;
		items[13].width = 405.00;
		items[13].height = 315.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"dependsOn":4,"outlineGlow":true});
	}
	if (items[14]) {
		PostcardNairobi2Layout_decorationNairobi21.call(items[14] as IPostcardNairobi2Layout_decorationNairobi21);
		(items[14] as IPostcardNairobi2Layout_decorationNairobi21).dependsOn = 4;
		(items[14] as IPostcardNairobi2Layout_decorationNairobi21).outlineGlow = true;
		items[14].x = -127.5;
		items[14].y = 387.7;
		items[14].width = 43.00;
		items[14].height = 71.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	const background = this.background;
	PostcardNairobi2Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardNairobi2Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardNairobi2Layout_background(this: IPostcardNairobi2Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-nairobi-2.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_cardTransform8(this: IPostcardNairobi2Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-2-8.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_cardTransform7(this: IPostcardNairobi2Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-2-7.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_cardTransform3(this: IPostcardNairobi2Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-2-3.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_cardTransform6(this: IPostcardNairobi2Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-2-6.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_cardTransform5(this: IPostcardNairobi2Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-2-5.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_cardTransform1(this: IPostcardNairobi2Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-2-1.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_cardTransform4(this: IPostcardNairobi2Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-2-4.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_cardTransform2(this: IPostcardNairobi2Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-nairobi-2-2.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_pieces8(this: IPostcardNairobi2Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-2-8.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_outlines8(this: IPostcardNairobi2Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-2-8.png", 0.500, 0.501);
	return this;
}
function PostcardNairobi2Layout_pieces7(this: IPostcardNairobi2Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-2-7.png", 0.501, 0.500);
	return this;
}
function PostcardNairobi2Layout_outlines7(this: IPostcardNairobi2Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-2-7.png", 0.501, 0.500);
	return this;
}
function PostcardNairobi2Layout_pieces6(this: IPostcardNairobi2Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-2-6.png", 0.502, 0.500);
	return this;
}
function PostcardNairobi2Layout_outlines6(this: IPostcardNairobi2Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-2-6.png", 0.502, 0.500);
	return this;
}
function PostcardNairobi2Layout_pieces2(this: IPostcardNairobi2Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-2-2.png", 0.500, 0.501);
	return this;
}
function PostcardNairobi2Layout_outlines2(this: IPostcardNairobi2Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-2-2.png", 0.501, 0.500);
	return this;
}
function PostcardNairobi2Layout_pieces5(this: IPostcardNairobi2Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-2-5.png", 0.500, 0.501);
	return this;
}
function PostcardNairobi2Layout_outlines5(this: IPostcardNairobi2Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-2-5.png", 0.500, 0.501);
	return this;
}
function PostcardNairobi2Layout_pieces4(this: IPostcardNairobi2Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-2-4.png", 0.501, 0.500);
	return this;
}
function PostcardNairobi2Layout_outlines4(this: IPostcardNairobi2Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-2-4.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_pieces1(this: IPostcardNairobi2Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-nairobi-2-1.png", 0.531, 0.500);
	return this;
}
function PostcardNairobi2Layout_outlines1(this: IPostcardNairobi2Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-nairobi-2-1.png", 0.501, 0.502);
	return this;
}
function PostcardNairobi2Layout_decorationNairobi21(this: IPostcardNairobi2Layout_decorationNairobi21) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-nairobi-2-1.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_postcardOverlay(this: IPostcardNairobi2Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardNairobi2Layout_postcardMask(this: IPostcardNairobi2Layout_postcardMask) {
	return this;
}
interface IPostcardNairobi2LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardNairobi2LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardNairobi2LayoutSprite extends IPostcardNairobi2LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardNairobi2LayoutText extends IPostcardNairobi2LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardNairobi2LayoutPolygon extends Array<number> {
}
interface IPostcardNairobi2Layout {
	readonly main: IPostcardNairobi2Layout_main;
}
interface IPostcardNairobi2Layout_main extends IPostcardNairobi2LayoutContainer {
	readonly postcard: IPostcardNairobi2Layout_postcard;
}
interface IPostcardNairobi2Layout_postcard extends IPostcardNairobi2LayoutContainer {
	readonly cardTransform: IPostcardNairobi2LayoutArray<IPostcardNairobi2Layout_cardTransform1|IPostcardNairobi2Layout_cardTransform2|IPostcardNairobi2Layout_cardTransform3|IPostcardNairobi2Layout_cardTransform4|IPostcardNairobi2Layout_cardTransform5|IPostcardNairobi2Layout_cardTransform6|IPostcardNairobi2Layout_cardTransform7|IPostcardNairobi2Layout_cardTransform8>;
	readonly items: IPostcardNairobi2LayoutArray<IPostcardNairobi2Layout_pieces8|IPostcardNairobi2Layout_outlines8|IPostcardNairobi2Layout_pieces7|IPostcardNairobi2Layout_outlines7|IPostcardNairobi2Layout_pieces6|IPostcardNairobi2Layout_outlines6|IPostcardNairobi2Layout_pieces2|IPostcardNairobi2Layout_outlines2|IPostcardNairobi2Layout_pieces5|IPostcardNairobi2Layout_outlines5|IPostcardNairobi2Layout_pieces4|IPostcardNairobi2Layout_outlines4|IPostcardNairobi2Layout_pieces1|IPostcardNairobi2Layout_outlines1|IPostcardNairobi2Layout_decorationNairobi21>;
	readonly background: IPostcardNairobi2Layout_background;
	readonly postcardOverlay: IPostcardNairobi2Layout_postcardOverlay;
	readonly postcardMask: IPostcardNairobi2Layout_postcardMask;
}
interface IPostcardNairobi2Layout_background extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_cardTransform8 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_cardTransform7 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_cardTransform3 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_cardTransform6 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_cardTransform5 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_cardTransform1 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_cardTransform4 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_cardTransform2 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_pieces8 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_outlines8 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_pieces7 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_outlines7 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_pieces6 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_outlines6 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_pieces2 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_outlines2 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_pieces5 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_outlines5 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_pieces4 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_outlines4 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_pieces1 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_outlines1 extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_decorationNairobi21 extends IPostcardNairobi2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardNairobi2Layout_postcardOverlay extends IPostcardNairobi2LayoutSprite {
}
interface IPostcardNairobi2Layout_postcardMask extends IPostcardNairobi2LayoutPolygon {
}
